var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListZeroState = function SvgListZeroState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#List_Zero_State_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#List_Zero_State_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8h47.115c.5 0 .98.177 1.333.493s.552.745.552 1.191v28.632c0 .447-.199.875-.552 1.19a2.004 2.004 0 0 1-1.333.494H5.385c-.5 0-.98-.177-1.333-.493a1.599 1.599 0 0 1-.552-1.191V8Z",
    fill: "#6794C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.115 8.045H3.5V3h18.846l3.77 5.045Zm7.539 5.046-3.77 5.045H3.5v20.182c0 .446.199.874.552 1.19.353.315.833.492 1.333.492h45.23c.5 0 .98-.177 1.333-.493.353-.315.552-.743.552-1.189V13.091H33.654Z",
    fill: "#9CB9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.392 40.125H24.045a10.969 10.969 0 1 1 21.347 0Z",
    fill: "#5095D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.406 26.625a10.969 10.969 0 1 0 0 21.937 10.969 10.969 0 0 0 0-21.937Zm0 20.25a9.28 9.28 0 1 1 0-18.561 9.28 9.28 0 0 1 0 18.561Z",
    fill: "#DC9B32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.687 47.719c-.464 0-.363 0-3.13-2.776a.847.847 0 0 1 1.198-1.198l2.531 2.531a.843.843 0 0 1-.599 1.443Z",
    fill: "#DC9B32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.406 46.875a9.281 9.281 0 1 0 0-18.563 9.281 9.281 0 0 0 0 18.563Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.813 37.594a9.281 9.281 0 0 1 8.437-9.24 9.281 9.281 0 1 0 0 18.52 9.281 9.281 0 0 1-8.437-9.28Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.812 54.612a2.405 2.405 0 0 1-4.219 1.586l-7.037-7.037a.844.844 0 0 1 0-1.198l2.177-2.177a.844.844 0 0 1 1.198 0l7.138 7.139a2.385 2.385 0 0 1 .743 1.687Z",
    fill: "#274673"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "List_Zero_State_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.5 3)",
    d: "M0 0h54v54H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "List_Zero_State_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.5 3)",
    d: "M0 0h54v54H0z"
  })))));
};
export default SvgListZeroState;